import * as React from 'react';
import {
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarExport,
  //GridToolbarDensitySelector,
  // useGridApiContext,
  //   GridCsvExportOptions,
  //   GridCsvGetRowsToExportParams,
  gridVisibleSortedRowIdsSelector
} from '@mui/x-data-grid';


function CustomToolbar() {
  
  //const apiRef = useGridApiContext();
  const getFilteredRows = ({ apiRef }) =>
    gridVisibleSortedRowIdsSelector(apiRef);
    
  //   const handleExport = (options) =>
  //   apiRef.current.exportDataAsCsv(options );
  return (
    <GridToolbarContainer>
      <GridToolbarColumnsButton />
      <GridToolbarFilterButton />
      {/* <GridToolbarDensitySelector />  */}
      {/* <GridToolbarExport
        csvOptions={{ allColumns: true, fileName: 'DataExport', getRowsToExport: getFilteredRows }}
        printOptions={{ disableToolbarButton: true }}
      /> */}
      {/* <Button
        {...buttonBaseProps}
        onClick={() => handleExport({ getRowsToExport: getFilteredRows })}
      >
        Filtered rows
      </Button> */}
    </GridToolbarContainer>
  );
}

export default CustomToolbar;